import { render, staticRenderFns } from "./EditSpeakers.vue?vue&type=template&id=04c0c846"
import script from "./EditSpeakers.vue?vue&type=script&lang=js"
export * from "./EditSpeakers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports